import { Box, Center, Text, UnstyledButton } from '@mantine/core';
import React from 'react';
import { ArrowLeft } from 'tabler-icons-react';

interface Props {
  handleClick: () => void;
}
function BackButton(props: Props) {
  const { handleClick } = props;
  return (
    <UnstyledButton
      color='dimmed'
      mt='lg'
      data-cy='backButton'
      onClick={() => {
        handleClick();
      }}
    >
      <Center inline>
        <ArrowLeft size={12} color='#868e96' />
        <Box ml={5}>
          <Text size='sm' color='dimmed'>
            Back
          </Text>
        </Box>
      </Center>
    </UnstyledButton>
  );
}

export default BackButton;
